import { Component, Input } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';

interface Donor {
  categoria: string;
  nome?: string;
  link?: string;
  icone?: string;
}

@Component({
  selector: 'app-donors',
  templateUrl: './donors.component.html',
  styleUrls: ['./donors.component.scss'],
})
export class DonorsComponent {
  @Input() description: boolean = false;
  donors!: Record<string, Donor[]>;

  donorPriority: Record<string, number> = {
    'Amado': 1,
    'Fantástico': 1,
    'Maravilha': 4,
    'Engajado': 5,
    'Apoio Institucional': 10
  };

  // regras específicas por domínio
  private readonly ICON_FIXES: { [pattern: string]: Partial<Donor> } = {
    'phomenta.com.br': {
      nome: 'Instituto Phomenta',
      icone: 'https://360interativo.com.br/images/ddd/Engajado/phomenta.png'
    },
    // 'outro-dominio.com': { nome: 'Outro Nome', icone: 'url...' }
  };

  constructor(private dashboardService: DashboardService) {
    this.dashboardService.dashboard.subscribe((res) => {
      if (!res) return;

      // console.log('Doadores recebidos:', res.doadores);

      // 1) normaliza tudo que veio do Firestore
      const normalized: Donor[] = (res.doadores || []).map((d: Donor) =>
        this.normalizeDonor(d)
      );

      // 2) agrupa por categoria
      const grouped = this.groupBy(normalized, 'categoria');

      // 3) ordena cada categoria alfabeticamente pelo nome
      Object.keys(grouped).forEach(categoria => {
        grouped[categoria] = grouped[categoria].sort((a: Donor, b: Donor) =>
          (a.nome || '').localeCompare(b.nome || '')
        );
      });

      this.donors = grouped;
    });
  }

  /**
   * Corrige nome/icone vazios usando o link ou regras específicas
   */
  private normalizeDonor(d: Donor): Donor {
    let donor: Donor = { ...d };

    // 1) aplica regra específica por domínio, se houver
    const fixEntry = Object.entries(this.ICON_FIXES)
      .find(([pattern]) => donor.link && donor.link.includes(pattern));

    if (fixEntry) {
      const [, fix] = fixEntry;
      donor = {
        ...donor, // mantém o que veio do Firestore
        ...fix    // sobrepõe com os ajustes
      };
    }

    // 2) se não tiver nome mas tiver link, gera a partir do domínio
    if (!donor.nome && donor.link) {
      try {
        const url = new URL(donor.link);
        const host = url.hostname.replace(/^www\./, '');
        let base = host.split('.')[0].replace(/[-_]/g, ' ');
        base = base.charAt(0).toUpperCase() + base.slice(1);
        donor.nome = base; // ex.: phomenta.com.br → Phomenta
      } catch {
        donor.nome = 'Parceiro';
      }
    }

    // 3) se ainda não tiver ícone, coloca um placeholder
    if (!donor.icone) {
      donor.icone = 'assets/img/doadores/placeholder.png'; // coloque um PNG seu aqui
    }

    return donor;
  }

  groupBy(input: Donor[], key: keyof Donor) {
    return input.reduce((acc: any, currentValue: Donor) => {
      const groupKey = currentValue[key] as string;
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(currentValue);
      return acc;
    }, {} as Record<string, Donor[]>);
  }

  get keys() {
    return Object.keys(this.donors).sort(
      (category, next) =>
        this.donorPriority[category] - this.donorPriority[next]
    );
  }
}
